/* eslint-disable quotes */
import { snakelize, camelize } from '../../../helpers/object'

export default ($axios: any): any => ({

  async uploadImage (data?: any) {
    const formData = new FormData()
    formData.append('image', data.image)
    formData.append('brand_token', data.brandToken)

    return camelize(await $axios.post('/brand/sns/image/upload', formData))
  },

  async copyImageFrom (data?: any) {
    return camelize(await $axios.post('/brand/sns/image/copy-from', snakelize(data)));
  },

  async searchBsProductsByName (data?: any) {
    return camelize(await $axios.get(`/brand/sns/products/search`, snakelize({ params: data })));
  },

  async createBsProduct (data?: any) {
    return camelize(await $axios.post(`/brand/sns/products`, snakelize(data)));
  },

  async updateBsProductUrl (data?: any) {
    return camelize(await $axios.put('/brand/sns/products/url', snakelize(data)))
  },



  async countYoutubes (data?: any) {
    return camelize(await $axios.get(`/brand/sns/youtubes/count`, snakelize({ params: data })));
  },

  async fetchYoutubes (data?: any) {
    return camelize(await $axios.get(`/brand/sns/youtubes`, snakelize({ params: data })));
  },

  async createYoutube (data?: any) {
    return camelize(await $axios.post(`/brand/sns/youtubes`, snakelize(data)));
  },

  async updateYoutube (id:number, data?:any) {
    return camelize(await $axios.put(`/brand/sns/youtubes/${id}`, snakelize(data)));
  },

  async orderYoutubes (data?: any) {
    return camelize(await $axios.put(`/brand/sns/youtubes/order`, snakelize(data)));
  },



  async countVideos (data?: any) {
    return camelize(await $axios.get(`/brand/sns/videos/count`, snakelize({ params: data })));
  },

  async fetchVideos (data?: any) {
    return camelize(await $axios.get(`/brand/sns/videos`, snakelize({ params: data })));
  },

  async createVideo (data?: any) {
    return camelize(await $axios.post(`/brand/sns/videos`, snakelize(data)));
  },

  async updateVideo (id:number, data?:any) {
    return camelize(await $axios.put(`/brand/sns/videos/${id}`, snakelize(data)));
  },

  async orderVideos (data?: any) {
    return camelize(await $axios.put(`/brand/sns/videos/order`, snakelize(data)));
  },




  async countCelebrities (data?: any) {
    return camelize(await $axios.get(`/brand/sns/celebrities/count`, snakelize({ params: data })));
  },

  async fetchCelebrities (data?: any) {
    return camelize(await $axios.get(`/brand/sns/celebrities`, snakelize({ params: data })));
  },

  async createCelebrity (data?: any) {
    return camelize(await $axios.post(`/brand/sns/celebrities`, snakelize(data)));
  },

  async updateCelebrity (id:number, data?:any) {
    return camelize(await $axios.put(`/brand/sns/celebrities/${id}`, snakelize(data)));
  },

  async orderCelebrities (data?: any) {
    return camelize(await $axios.put(`/brand/sns/celebrities/order`, snakelize(data)));
  },



  // deprecated. only for celeb
  async updateCelebProductUrl (data?: any) {
    return camelize(await $axios.put('/brand/sns/celebrities/product-url', snakelize(data)))
  },

})
